module.exports = __webpack_public_path__ + "static/media/catamaran-extrabold-webfont.02f73471.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/fonts/catamaran-extrabold-webfont.woff2
// module id = 1516
// module chunks = 0